import dayjs, { type Dayjs } from 'dayjs'

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function isDate(value: unknown): value is Date {
  return value instanceof Date
}

function isDayjs(value: unknown): value is Dayjs {
  // dayjs exports a type guard, but this runtime check keeps it lightweight
  return dayjs.isDayjs(value)
}

export function valueEquals(a: unknown, b: unknown): boolean {
  if (a === b) return true
  if (a == null || b == null) return a === b

  // Dayjs
  if (isDayjs(a) && isDayjs(b)) return a.isSame(b)

  // Date
  if (isDate(a) && isDate(b)) return a.getTime() === b.getTime()

  // Array
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
      if (!valueEquals(a[i], b[i])) return false
    }
    return true
  }

  // Object
  if (isObject(a) && isObject(b)) {
    const ak = Object.keys(a)
    const bk = Object.keys(b)
    if (ak.length !== bk.length) return false
    for (const key of ak) {
      if (!Object.hasOwn(b, key)) return false
      if (!valueEquals(a[key], b[key])) return false
    }
    return true
  }

  // Fallback
  return a === b
}
